module.exports = __webpack_public_path__ + "static/media/close-gray.3dc88b02.svg";